import { getData } from '@/services/api.service';
import React, { useEffect, useState } from 'react';
import BannerSection from '../sections/banner-section';
import BannerEditModal from './modals/banner-edit-modal';
import TrustSection from '../sections/trust-section';
import TrustEditModal from './modals/trust-edit-modal';
import PrioritySection from '../sections/priority-section';
import PriorityEditModal from './modals/priority-edit-modal';
import MobileAppSection from '../sections/mobile-app-section';
import MobileAppEditModal from './modals/mobile-app-edit-modal';
import Header1 from '@/feature-module/common/header/header-1';
import Header2EditModal from '@/feature-module/common/header/edit/modals/header2-edit-modal';
import Header1EditModal from '@/feature-module/common/header/edit/modals/header1-edit-modal';

const Home1Edit = ({ themeData, fetchData }: any) => {
  return (
    <>
      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#headerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <>
          <Header1 themeData={themeData} />
        </>
      </div> */}
      {/* <div
        className="modal fade"
        id="headerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <Header1EditModal themeData={themeData} fetchData={fetchData} />
      </div> */}

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#bannerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <BannerSection themeData={themeData} theme_5={themeData?.theme_5} />
      </div>
      <div
        className="modal fade"
        id="bannerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <BannerEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#trustEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <TrustSection themeData={themeData} theme_5={themeData?.theme_5} />
      </div>
      <div
        className="modal fade"
        id="trustEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <TrustEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#priorityEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <PrioritySection themeData={themeData} theme_5={themeData?.theme_5} />
      </div>
      <div
        className="modal fade"
        id="priorityEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <PriorityEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#mobileAppEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <MobileAppSection themeData={themeData} theme_5={themeData?.theme_5} />
      </div>
      <div
        className="modal fade"
        id="mobileAppEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <MobileAppEditModal themeData={themeData} getThemeData={fetchData} />
      </div>
    </>
  );
};

export default Home1Edit;
